import Plugin from '@ckeditor/ckeditor5-core/src/plugin'
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview'

export default class ViiluIndentUI extends Plugin {
	init() {
		const editor = this.editor

		editor.ui.componentFactory.add('viiluindent', (locale) => {
			const view = new ButtonView(locale)

			view.set({
				label: 'Sisennys',
				withText: true,
				tooltip: true,
			})

			// Callback executed once the toolbar icon is clicked.
			view.on('execute', () => {
				editor.execute('viiluindent')
				editor.editing.view.focus()
			})

			return view
		})
	}
}
